import { gql } from '__generated__';

export default gql(`
  query GetRefundDetails($order_id: ID!) {
    order(id: $order_id) {
      id
      invoice_id
      refund_options {
        payment {
          id
          payment_method
          status_changed_at
          amount
          refundable_amount
          consumer_account
          created_at
        }
        items {
          purchase {
            id
            revenue
            batch_size
            active
            ticket {
              id
              title
            }
            product {
              id
              title
            }
            product_variant {
              id
              title
            }
            registration {
              id
              sequence
            }
          }
          amount
        }
      }
    }
  }
`);
